import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('grepTester', app)
  return store
}
